import React from "react";

const defaultTargetsDisclosureData = [
  {
    sno: 1,
    targetNameIFRS: "",
    defineTargetIFRS: "",
    metricUsedMonitorIFRS: "",
    specifyQuantQualTargetIFRS: "",
    periodIFRS: "",
    basePeriodMeasuredIFRS: "",
    milestonesInterimTargetsIFRS: "",
    performanceTrendsIFRS: "",
    targetRevisionsIFRS: "",
  },
];

const TargetsDisclosureTable = ({
  targetsDisclosureData,
  setTargetsDisclosureData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...targetsDisclosureData];
    updated[index][field] = value;
    setTargetsDisclosureData(updated);
  };
  const renumberRows = (arr) => arr.map((r, i) => ({ ...r, sno: i + 1 }));

  const addRow = () =>
    setTargetsDisclosureData([
      ...targetsDisclosureData,
      {
        sno: (targetsDisclosureData?.length || 0) + 1,
        targetNameIFRS: "",
        defineTargetIFRS: "",
        metricUsedMonitorIFRS: "",
        specifyQuantQualTargetIFRS: "",
        periodIFRS: "",
        basePeriodMeasuredIFRS: "",
        milestonesInterimTargetsIFRS: "",
        performanceTrendsIFRS: "",
        targetRevisionsIFRS: "",
      },
    ]);

  const removeRow = () => {
    if (targetsDisclosureData.length > 1) {
      setTargetsDisclosureData(
        renumberRows(targetsDisclosureData.slice(0, -1))
      );
    }
  };

  // remove per-cell borders; outer frame + inner grid will handle corners
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };
  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };
  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };
  const textAreaStyle = {
    ...inputStyle,
    minHeight: "70px",
    resize: "vertical",
  };
  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      {/* table frame + perfect corners */}
      <style>{`
        .tdTableFrame{
          border: 1px solid #000;
          border-radius: 8px;
          overflow: hidden;
        }
        .tdTable{
          width: 100%;
          border-collapse: collapse;
        }
        .tdTable th,
        .tdTable td{
          border: 1px solid #000; /* inner grid lines */
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .tdTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide only the outer edges; the frame draws the outside border */
        .tdTable thead tr:first-child th{ border-top: 0; }
        .tdTable tr th:first-child,
        .tdTable tr td:first-child{ border-left: 0; }
        .tdTable tr th:last-child,
        .tdTable tr td:last-child{ border-right: 0; }
        .tdTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <div className="tdTableFrame">
        <table className="tdTable">
          <thead>
            <tr>
              <th style={{ ...header, width: 70 }}>
                S.
                <br />
                NO.
              </th>
              <th style={header}>Target name</th>
              <th style={header}>Define the target</th>
              <th style={header}>
                Metric used to set the target and to monitor progress
              </th>
              <th style={header}>Specify quantitative/qualitative target</th>
              <th style={header}>Period</th>
              <th style={header}>
                Base period from which progress is measured
              </th>
              <th style={header}>Milestones and interim targets</th>
              <th style={header}>Performance and trends</th>
              <th style={header}>Target revisions</th>
            </tr>
          </thead>

          <tbody>
            {targetsDisclosureData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{row.sno || index + 1}.</td>

                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.targetNameIFRS}
                    onChange={(e) =>
                      handleChange(index, "targetNameIFRS", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.defineTargetIFRS}
                    onChange={(e) =>
                      handleChange(index, "defineTargetIFRS", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.metricUsedMonitorIFRS}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "metricUsedMonitorIFRS",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={
                      row.specificQuantQualTargetIFRS ??
                      row.specifyQuantQualTargetIFRS
                    }
                    onChange={(e) =>
                      handleChange(
                        index,
                        "specifyQuantQualTargetIFRS",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.periodIFRS}
                    onChange={(e) =>
                      handleChange(index, "periodIFRS", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.basePeriodMeasuredIFRS}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "basePeriodMeasuredIFRS",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.milestonesInterimTargetsIFRS}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "milestonesInterimTargetsIFRS",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.performanceTrendsIFRS}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "performanceTrendsIFRS",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.targetRevisionsIFRS}
                    onChange={(e) =>
                      handleChange(index, "targetRevisionsIFRS", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          gap: 10,
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default TargetsDisclosureTable;
